module.exports = __webpack_public_path__ + "img/20200515_162802.0237a6b3.jpg";